import NavigatedViewer from 'bpmn-js/lib/NavigatedViewer.js';

export class Viewer extends NavigatedViewer {

  constructor(options: any) {
    super(options);
  }
  canvas() {
    return this.get('canvas');
  }

  elementRegistry() {
    return this.get('elementRegistry');
  }
  get(key: string) {
    return super.get(key);
  }
}
